<template>
  <b-form-group :id="`${getInputId}-group-${_uid}`"
                :label="label"
                :label-for="`${getInputId}-${_uid}`"
                v-if="getUserProfileClone"
                label-cols="3">

    <b-checkbox switch v-if="type === 'isActive'" :id="`${getInputId}-${_uid}`" :checked="getValue" @input.native="updateUserClone"/>

    <b-form-input :id="`${getInputId}-${_uid}`"
                  :type="type"
                  :size="size"
                  :min="min"
                  :value="getValue"
                  @input.native="updateUserClone"
                  autocomplete="off"
                  :placeholder="placeHolder"
                  v-else>
    </b-form-input>

    <b-form-text :id="`${getInputId}-group-${_uid}-help`" v-if="type === 'email'">(Changer d'adresse email nécessite de se reconnecter)</b-form-text>


    <!-- Alert -->
    <ValidationErrorAlert :form-error-list="getFormError"/>

  </b-form-group>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UserInputType',
  props: {
    type: { type: String, required: true },
    size: { type: String, required: false },
    min: { type: Number, required: false },
    label: { type: String, required: true },
    placeHolder: { type: String, required: false },
    userProperty: {
      type: String,
      required: true,
      validator(value) {
        return [
          'username',
          'lastName',
          'firstName',
          'email',
          'password',
          'isActive',
        ].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'getUserProfileClone',
    ]),
    getInputId() {
      return `patch-user-${this.userProperty}`;
    },
    getFormError() {
      return this.getFormPatchUserError()[this.userProperty] || [];
    },
    getValue() {
      return this.getUserProfileClone[this.userProperty] === null ? 'NR' : this.getUserProfileClone[this.userProperty];
    },
  },
  methods: {
    ...mapGetters([
      'getFormPatchUserError',
    ]),
    updateUserClone(e) {
      let value;
      if (e.target.type === 'checkbox') {
        value = e.target.checked;
      } else {
        value = e.target.value;
      }
      this.$store.commit('setUserProfileCloneProperty', { userProperty: this.userProperty, value: value });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .user-input-email-legend {
    display: block;
    font-size: 11px;
    font-weight: lighter;
    font-style: italic;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/user/input/UserInputType.vue